export interface TierPricing {
  price: string
  unit?: string
  tagline: string
}

// Normalizes feature / tier names so overrides survive small wording changes
export function normalizeKey(value: string) {
  return value.toLowerCase().replace(/[^a-z0-9]/g, '')
}

// Display names for license columns whose CSV header differs from the brand name
export const tierDisplayNames: {
  [key: string]: string
} = {
  max: 'Ultra',
}

// Corrections applied on top of the pricing CSV, keyed by feature then license.
// Feature keys match partially, so "fleetwifisharing" also covers
// "Fleet Wi-Fi Sharing (Enterprise)".
export const featureValueOverrides: {
  [feature: string]: {
    [tier: string]: string
  }
} = {
  fleetwifisharing: {
    pro: '—',
  },
}

export function findFeatureOverrides(feature: string) {
  const featureKey = normalizeKey(feature)
  const match = Object.keys(featureValueOverrides).find((key) =>
    featureKey.includes(key),
  )
  return match ? featureValueOverrides[match] : undefined
}

// Keyed by the license name used in the pricing CSV (lowercased)
export const tierPricing: {
  [key: string]: TierPricing
} = {
  core: {
    price: 'Free',
    tagline: 'Everything you need to work hands-free.',
  },
  pro: {
    price: '$9.90',
    unit: 'per device / month',
    tagline: 'Deeper AI, more cloud, more control.',
  },
  ultra: {
    price: '$19.90',
    unit: 'per device / month',
    tagline: 'The complete platform, at fleet scale.',
  },
}
